<template>
    <div class="print-container">
        <el-form ref="printForm" label-position="left" label-width="0px" class="card-box print-form">
            <el-form-item>
                <el-button type="primary" @click.native.prevent="print">
                    打印此页
                </el-button>
                <el-button type="primary" @click.native.prevent="close">
                    关闭此页
                </el-button>
            </el-form-item>
          <el-form-item>
            <hr>
          </el-form-item>
            <el-form-item>
              <p><span>{{$t("wm_lang_html_df23a5")}}</span>{{mailContData.subject}}</p>
              <p><span>{{$t("wm_lang_html_2df6a3")}}</span>{{mailContData.from}}<span>&nbsp;&nbsp;&nbsp;&nbsp;{{$t("wm_lang_html_14e6d8")}}</span>{{this.$moment(mailContData.sendDate).format('YYYY-MM-DD HH:mm:ss')}}</p>
              <p><span>{{$t("wm_lang_html_ac1e1c")}}</span>{{mailContData.to.join(',')}}</p>
              <p><span v-if="mailContData.cc.length > 0">{{$t("wm_lang_html_c00500")}}</span>{{mailContData.cc.join(',')}}</p>
            </el-form-item>
          <el-form-item>
            <hr>
          </el-form-item>
          <el-form-item>
            <div class="f14" v-html="mailContData.mailText"></div>
          </el-form-item>
        </el-form>
    </div>
</template>

<script>
  import storeLocal from 'store';
    export default {
      components: { },
      name: 'print',
      data() {
        return {
          mailContData: null
        }
      },
      methods: {
        print() {
          window.print();
        },
        close() {
          window.close();
        }
      },
      mounted() {
        // console.log(this.$route.query.mailId);
        this.mailContData = storeLocal.get('ls_print_mail');
        // console.log(this.mailContData)
      }
    }
</script>

<style scoped>
    .print-container {
      position: relative;
      height: 100vh;
      background-color: #ffffff;
    }
    .print-form {
      position: absolute;
      left: 0;
      right: 0;
      padding: 35px 35px 15px 35px;
      margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/login/mailPrint.vue